var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSigned(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M22.8036 18.8845L26.5599 16.0759L23.6835 12.4389L24.674 7.90114L20.1062 6.88196L17.8667 2.73581L13.745 4.80927L9.32082 2.99604L7.57176 7.19308L3.03621 8.56006L4.48019 12.9155L1.95365 16.8249L5.91469 19.3033L6.58009 23.9244L11.2032 23.3636L14.7506 26.5351L17.8744 23.1989L22.6429 23.4364L22.8036 18.8845Z",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.58301 14.3475L12.7651 17.3196L18.5969 11.421",
    fill: "none",
    "data-nofill": "true"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSigned);
export default __webpack_public_path__ + "static/media/signed.f48bfb32532edec317034ffd2882472c.svg";
export { ForwardRef as ReactComponent };